import type { TOC } from '@ember/component/template-only';

import CommonUiIcon from 'webapp/components/common/ui-icon';

interface CommonSmartAlertIconComponentInterface {
	Element: HTMLSpanElement;
	Args: {
		isLocked?: boolean;
		isActive?: boolean;
	};
}

const CommonSmartAlertIconComponent: TOC<CommonSmartAlertIconComponentInterface> = <template>
	<span class="smart-alert-icon" ...attributes>
		<CommonUiIcon @name="SmartAlert" @size="md" />
		{{#if @isLocked}}
			<CommonUiIcon @name="Lock" @size="xs" @class="smart-alert-icon__lock" />
		{{/if}}
	</span>
</template>;

export default CommonSmartAlertIconComponent;
